import { create } from 'zustand';
import type { SesionActiva } from '@shared/types';

interface SessionState {
  sesion: SesionActiva | null;
  setSesion: (s: SesionActiva | null) => void;
  esDueno: () => boolean;
  esMesero: () => boolean;
}

/** Sprint 166 — "Esta pestaña ya entró": la única condición para volver sin PIN al recargar. */
export const MARCA_PESTANA = 'pos-sesion-en-esta-pestana';

export const useSessionStore = create<SessionState>((set, get) => ({
  sesion: null,
  setSesion: (s) => {
    /*
      Sprint 166 (auditoría `cyber`) — La marca vive en sessionStorage: sobrevive a recargar ESTA pestaña
      (la puesta al día automática), pero no a cerrar el navegador ni a abrir otra pestaña. En una caja
      compartida, quien abra el navegador después tiene que teclear su PIN.
    */
    try {
      if (s) sessionStorage.setItem(MARCA_PESTANA, '1');
      else sessionStorage.removeItem(MARCA_PESTANA);
    } catch {
      /* sin sessionStorage (escritorio raro): no se restaura nada */
    }
    set({ sesion: s });
  },
  esDueno: () => get().sesion?.rol === 'dueño',
  esMesero: () => get().sesion?.rol === 'mesero',
}));
